module.exports = __webpack_public_path__ + "img/reservationBack.e4af5bb3.svg";